import React, {useState} from 'react';
import NewContactEmailRow from "./components/new-contact-email-row";

function NewContactEmailRows ({email}) {

    let defaultEmailAddressRows = [{
        "id": "0",
        "label":"",
        "email":""
    }];

    const [emailAddressRows, setEmailAddressRows] = useState(defaultEmailAddressRows);

    const handleNewEmailRow = () => {
        setEmailAddressRows([
            ...emailAddressRows,
            {
                "id": (parseInt(emailAddressRows[emailAddressRows.length - 1].id, 10) + 1).toString(),
                "label":"",
                "email":""
            }
        ])
    };

    const handleDeleteEmailRow = (e) => {
        setEmailAddressRows(emailAddressRows.filter((emailAddressRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
    };

    return (
        <div className="border-top py-3">
            {
                emailAddressRows.map((emailAddress, index) => (
                    <NewContactEmailRow
                        key={emailAddress.id}
                        emailAddress={email && index ===0?{email}:emailAddress.email}
                        index={index}
                        newEmailRow={handleNewEmailRow}
                        deleteEmailRow={handleDeleteEmailRow}
                    />
                ))
            }
        </div>
    )

}

export default NewContactEmailRows;